import React, { useState } from "react";
import firebaseApp from "./fireconnect";
import { toast, ToastContainer } from "react-toastify";
import { FaUser, FaPhone, FaMapMarkerAlt, FaQuestionCircle, FaCheckCircle, FaHeadset, FaTruck, FaShieldAlt, FaWater, FaLock } from "react-icons/fa";

export default function HomeTopForm() {
  const [formData, setFormData] = useState({
    fullName: "",
    location: "",
    phone: "",
    Inquiry: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const { fullName, location, phone, Inquiry } = formData;
    const phoneRegex = /^[6789]\d{9}$/;

    if (!phoneRegex.test(phone)) {
      toast.error("Please enter a valid 10-digit phone number.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setIsSubmitting(false);
      return;
    }

    if (!fullName || !location || !phone || !Inquiry) {
      toast.error("Please fill in all the fields.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setIsSubmitting(false);
      return;
    }

    const db = firebaseApp.firestore();

    try {
      await db.collection("InquiryFormData").add({
        fullName,
        location,
        phone,
        Inquiry,
        createdAt: new Date(),
      });

      toast.success("Form submitted successfully! We'll contact you soon.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      setFormData({
        fullName: "",
        location: "",
        phone: "",
        Inquiry: "",
      });
    } catch (error) {
      console.error("Error submitting form: ", error);
      toast.error("There was an error submitting your form. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const features = [
    { icon: <FaCheckCircle />, text: "100% Pure Water Guaranteed" },
    { icon: <FaHeadset />, text: "24/7 Customer Support" },
    { icon: <FaTruck />, text: "Free Installation & Delivery" },
    { icon: <FaShieldAlt />, text: "1 Year Warranty on All Products" },
  ];

  return (
    <section className="home-top-section">
      <div className="container py-5">
        <div className="row align-items-center">
          {/* Left Content */}
          <div className="col-lg-7 col-md-12 mb-lg-0 mb-5">
            <div className="text-lg-start text-center">
              <span className="section-badge mb-3">
                <FaWater className="me-2" /> Trusted by 10,000+ Customers
              </span>

              <h1 className="main-heading text-light mb-3">
                Premium <span className="highlight-text">Water Filters</span>
                <br className="d-none d-lg-block" /> by{" "}
                <span className="highlight-text">Bliss Water Technology</span>
              </h1>

              <h3 className="sub-heading text-light mb-4" style={{ opacity: 0.9 }}>
                Improve Your Water Quality Today with Our Advanced Filters.
              </h3>

              <p className="description text-light mb-4" style={{ maxWidth: '600px' }}>
                At Bliss Water Technology, we offer the best water filtration
                solutions for your home or business. Our premium filters ensure
                clean, safe, and healthy drinking water.
              </p>

              {/* Feature Badges */}
              <div className="feature-badges mt-4">
                <div className="row g-3">
                  {features.map((feature, index) => (
                    <div key={index} className="col-lg-6 col-md-6 col-12">
                      <div className="feature-badge d-flex align-items-center gap-2">
                        <span className="feature-icon">{feature.icon}</span>
                        <span className="feature-text">{feature.text}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Right Form */}
          <div className="col-lg-5 col-md-12">
            <div className="contact-form-section">
              <div className="form-header text-center mb-4">
                <div className="form-icon-wrapper mb-3">
                  <FaQuestionCircle size={28} />
                </div>
                <h4 className="text-light mb-1 fw-bold">Get Free Quote</h4>
                <p className="text-light mb-0" style={{ opacity: 0.8, fontSize: '14px' }}>
                  Fill in your details and we'll contact you
                </p>
              </div>

              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group input-with-icon">
                  <FaUser className="input-icon" />
                  <input
                    type="text"
                    name="fullName"
                    placeholder="Your Full Name"
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                    className="form-control"
                  />
                </div>

                <div className="form-group input-with-icon">
                  <FaPhone className="input-icon" />
                  <input
                    maxLength={10}
                    name="phone"
                    placeholder="Phone Number"
                    value={formData.phone}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>

                <div className="form-group input-with-icon">
                  <FaMapMarkerAlt className="input-icon" />
                  <input
                    type="text"
                    name="location"
                    placeholder="Your City / Location"
                    value={formData.location}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>

                <div className="form-group input-with-icon">
                  <FaQuestionCircle className="input-icon" />
                  <input
                    type="text"
                    name="Inquiry"
                    placeholder="What are you looking for?"
                    value={formData.Inquiry}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="btn-submit01 w-100"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Sending...
                    </>
                  ) : (
                    "Get Free Quote →"
                  )}
                </button>

                <p className="text-center text-light mt-3 mb-0" style={{ fontSize: '12px', opacity: 0.7 }}>
                  <FaLock className="me-1" /> Your information is 100% secure
                </p>
              </form>
              <ToastContainer />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

